// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium admin specific overrides for forms */

/* Makes radio buttons sidewize */
.ta .radio {
  display: inline-block;
}

.ta .radio:nth-child(1) {
  margin-left: 5px;
}

.ta .radio:nth-child(2) {
  margin-left: 36px;
}

/* Make the dropdowns larger for TA forms */
.ta .selectContainer .fakeSelectElement {
  height: 25px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/ta/forms.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,iCAAiC;AACjC;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;AACd","sourcesContent":["/* Premium admin specific overrides for forms */\n\n/* Makes radio buttons sidewize */\n.ta .radio {\n  display: inline-block;\n}\n\n.ta .radio:nth-child(1) {\n  margin-left: 5px;\n}\n\n.ta .radio:nth-child(2) {\n  margin-left: 36px;\n}\n\n/* Make the dropdowns larger for TA forms */\n.ta .selectContainer .fakeSelectElement {\n  height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
